import React from "react";
import { ChevronRight } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { floatToCurrency } from "../../../../constants/validate";
import SectionHeader from "../SectionHeader";

import "./index.scss";

function SelectInstallments({ handleChangeStep }) {
  const { activeProposals } = useSelector((state) => state.charge);
  const dispatch = useDispatch();

  function handleGoBack() {
    // if (debtInfo.status === "NEGOTIATION") {
    //   handleChangeStep(8)
    //   return
    // }

    handleChangeStep(1);
  }

  function handleSubmit(proposal) {
    dispatch({ type: "CHANGE_PREVIOUS_STEP", payload: 2 });
    dispatch({
      type: "CHANGE_PAYMENT",
      payload: {
        numberInstallments: proposal.currentInstallment,
        valueInstallments: proposal.value,
        proposalId: proposal.id,
      },
    });
    handleChangeStep(3);
  }

  function formatProposals() {
    const formattedProposals = activeProposals
      .slice(1)
      .map((proposal, index) => ({
        currentInstallment: index + 2,
        value: Number(proposal.value),
        total: proposal.value * (index + 2),
        id: proposal.id,
        interestRate: proposal.interest_rate,
      }));

    return formattedProposals;
  }

  return (
    <div className="select-installments">
      <SectionHeader handleGoBack={handleGoBack}>
        <h2>Selecione a quantidade de parcelas </h2>
      </SectionHeader>
      <section>
        {formatProposals().map((installment, index) => {
          const installmentValueSplitted = floatToCurrency(
            installment.value
          ).split(",");

          return (
            <div
              key={index}
              className="select-installments__option"
              onClick={() => handleSubmit(installment)}
            >
              <div className="select-installments__conditions">
                <div>
                  <p>{installment.currentInstallment}x</p>
                  <p>
                    {installmentValueSplitted[0]}
                    <sup>{installmentValueSplitted[1]}</sup>
                  </p>
                </div>
                <div>
                  {/* <p>Juros ${installment.interestRate}%</p> */}
                  <p>Total {floatToCurrency(installment.total)}</p>
                </div>
              </div>
              <ChevronRight />
            </div>
          );
        })}
      </section>
    </div>
  );
}

export default SelectInstallments;
